import { render, staticRenderFns } from "./user-notification.vue?vue&type=template&id=4dd0c523&"
import script from "./user-notification.vue?vue&type=script&lang=js&"
export * from "./user-notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports